<template>
  <div id="page-wrapper">
    <account-summary></account-summary>
    <!-- /.row -->
    <div class="row">
      <div class="col-lg-5">
        <div class="panel panel-default panel-account-number">
          <div class="panel-heading">{{$t('dashboard.account_information')}}</div>
          <div class="panel-body">
            <div class="row">
              <div class="col-sm-8">
                <div class="account-number">
                    <div>
                      <p class="bank">{{dashboard.fullName}}</p>
                      <p class="status">{{$t('dashboard.status')}}: {{$t('dashboard.status_list[0]')}}</p>
                      <mt4-account-list></mt4-account-list>
                    </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <img class="img-responsive" src="/static/assets/images/account.png" alt="account">
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <div class="panel panel-default panel-details">
          <div class="panel-heading">{{$t('dashboard.account_description')}}</div>
          <div class="panel-body">
            <div class="form-group row">
              <div class="col-md-3 col-xl-3">
                <label class="label-horizontal">{{$t('dashboard.account_type')}}</label>
              </div>
              <div class="col-md-9 col-xl-9">
                <span
                  v-html="defaultMT4Account && defaultMT4Account.accountType ? defaultMT4Account.accountType.description : ''"
                ></span>
              </div>
            </div>
            <mt4-account-details></mt4-account-details>
          </div>
        </div>
      </div>
    </div>
    <!-- /.row -->
    <div class="row">
      <div class="col-lg-7 col-xl-8">
        <div class="panel panel-default panel-white">
          <div class="panel-heading">{{$t('dashboard.account_value')}}</div>
          <balance-widget :from="balanceWidget.from" :to="balanceWidget.to"></balance-widget>
          <!-- /.panel-body -->
        </div>
      </div>
      <div class="col-lg-5 col-xl-4">
        <div class="panel panel-default">
          <div class="panel-heading">{{$t('dashboard.deposit_funds')}}</div>
          <!-- /.panel-heading -->
          <div class="panel-body deposit-funds panel-body-deposit-funds">
            <div class="row">
              <div class="col-xs-4" v-for="v in amounts" v-on:click="selectAmount(v)">
                <div :class="selectedAmount == v ? 'deposit selected' : 'deposit'">
                  <label>{{v}}</label>
                  <span>{{defaultCurrency}}</span>
                </div>
              </div>
            </div>
            <div class="space-40"></div>

            <div class="row">
              <div class="col-xs-3">
                <div class="payment-method">
                  <img
                    class="img-responsive"
                    src="/static/assets/images/bank-transfer.jpg"
                    alt="Bank Transfer"
                  >
                </div>
              </div>
              <div class="col-xs-3">
                <div class="payment-method">
                  <img class="img-responsive" src="/static/assets/images/visa.jpg" alt="visa">
                </div>
              </div>
              <div class="col-xs-3">
                <div class="payment-method">
                  <img
                    class="img-responsive"
                    src="/static/assets/images/mastercard.jpg"
                    alt="mastercard"
                  >
                </div>
              </div>
              <div class="col-xs-3">
                <div class="payment-method selected">
                  <img
                    class="img-responsive"
                    src="/static/assets/images/secure.jpg"
                    alt="SSL Secure"
                  >
                </div>
              </div>
            </div>
            <div class="align-center">
              <button
                type="button"
                v-on:click="goToDeposit"
                class="btn btn-primary"
              >{{$t('dashboard.make_deposit')}}</button>
            </div>
          </div>
          <!-- /.panel-body -->
        </div>
      </div>
    </div>
    <!-- /.row -->
    <div class="row panels-information">
      <div class="col-lg-12 col-xl-4">
        <div class="panel panel-default panel-details">
          <div class="panel-heading">
            {{$t('dashboard.personal_details')}}
            <div class="pull-right">
              <div class="btn-group">
                <a href="#" class="panel-menu" data-toggle="dropdown">
                  <i class="fa fa-ellipsis-h"></i>
                </a>
                <ul class="dropdown-menu pull-right" role="menu">
                  <li>
                    <a href="/client/profile">{{$t('dashboard.edit')}}</a>
                  </li>
                  <li>
                    <a href="/client/profile">{{$t('dashboard.change_password')}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /.panel-heading -->
          <div class="panel-body">
            <div class="form-group row">
              <div class="col-md-3">
                <label class="label-horizontal">{{$t('dashboard.first_name')}}</label>
              </div>
              <div class="col-md-9">
                <span>{{dashboard.firstName}}</span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-3">
                <label class="label-horizontal">{{$t('dashboard.last_name')}}</label>
              </div>
              <div class="col-md-9">
                <span>{{dashboard.lastName}}</span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-3">
                <label class="label-horizontal">{{$t('dashboard.phone')}}</label>
              </div>
              <div class="col-md-9">
                <span>{{dashboard.phone}}</span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-3">
                <label class="label-horizontal">{{$t('dashboard.email')}}</label>
              </div>
              <div class="col-md-9">
                <span>{{dashboard.email}}</span>
              </div>
            </div>
          </div>
          <!-- /.panel-body -->
        </div>
      </div>
      <div class="col-lg-6 col-xl-4">
        <div class="panel panel-default panel-details panel-white">
          <div class="loader-container" v-show="loader.news">
            <div class="loader"></div>
          </div>
          <div class="panel-heading">
            {{$t('dashboard.news')}}
            <div class="pull-right">
              <div class="btn-group">
                <a
                  href="javascript:void(0)"
                  v-on:click="populateNews()"
                  class="panel-menu"
                  data-toggle="dropdown"
                >
                  <i class="fas fa-sync-alt"></i>
                </a>
              </div>
            </div>
          </div>
          <!-- /.panel-heading -->
          <div class="panel-body panel-scroll">
            <ul v-if="news" class="chat">
              <li class="left clearfix" v-for="t in news">
                <div class="chat-img pull-left">
                  <img
                    :src="t && t.item && t.item.enclosure ? t.item.enclosure['@url'] : '/static/assets/images/news/empty.png'"
                    :alt="t.item.title"
                    class="img-circle"
                  >
                </div>
                <div class="chat-body clearfix">
                  <div class="header">
                    <a target="_blank" :href="t.item.link" class="img">{{t.item.title}}</a>
                  </div>
                  <p>{{t.item.pubDate}}</p>
                </div>
              </li>
            </ul>
          </div>
          <!-- /.panel-body -->
        </div>
      </div>
      <!-- <div class="col-lg-6 col-xl-4">
        <div class="panel panel-default panel-details">
          <div class="loader-container" v-show="loader.posts">
            <div class="loader"></div>
          </div>
          <div class="panel-heading">
            {{$t('dashboard.blog')}}
            <div class="pull-right">
              <div class="btn-group">
                <a
                  href="javascript:void(0)"
                  class="view-all"
                  data-toggle="dropdown"
                >{{$t('dashboard.view_all')}}</a>
                <a
                  href="javascript:void(0)"
                  v-on:click="populateLatestPosts()"
                  class="panel-menu"
                  data-toggle="dropdown"
                >
                  <i class="fas fa-sync-alt"></i>
                </a>
              </div>
            </div>
          </div> -->
          <!-- /.panel-heading -->
          <!-- <div class="panel-body panel-scroll">
            <ul class="chat">
              <li class="clearfix" v-for="p in posts">
                <div class="chat-body clearfix">
                  <div class="header">
                    <a :href="p.url" target="_blank">{{p.title}}</a>
                  </div>
                  <div v-html="p.excerpt"></div>
                  <a :href="p.url" class="show-more">{{$t('dashboard.show_more')}}</a>
                </div>
              </li>
            </ul>
          </div> -->
          <!-- /.panel-body -->
        <!-- </div>
      </div> -->
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import EventBus from "@/event-bus";
import DashboardService from "@/services/DashboardService";
import AccountService from "@/services/AccountService";
import BalanceWidget from "@/components/BalanceWidget";
import MT4AccountDetails from "@/components/MT4AccountDetails";
import Mt4AccountList from "@/components/Mt4AccountList";
import ProfileService from "@/services/ProfileService";
import siteConfiguration from '@/config';

let srv = new ProfileService();
let dashSrv = new DashboardService();
let accountService = new AccountService();

export default {
  components: {
    "balance-widget": BalanceWidget,
    "mt4-account-details": MT4AccountDetails,
    "mt4-account-list": Mt4AccountList
  },
  name: "Dashboard",
  data: function() {
    return {
      dashboard: {},
      defaultMT4Account: {},
      balanceWidget: {
        from: "20000101",
        to: "20190101"
      },
      amounts : siteConfiguration.DEPOSIT_AMOUNTS,
      defaultCurrency : siteConfiguration.DEFAULT_CURRENCY,
      selectedAmount: 1000,
      news: [],
      posts: [],
      loader: {
        news: true,
        posts: true
      }
    };
  },
  created() {
    EventBus.$on('onUpdateDefaultMt4Account', (r)=>{
        this.populateComponent(r);
    });
   
    srv.get().then(r=>{
      this.dashboard = r.data;
    });

    this.populateNews();
    this.populateLatestPosts();
    this.populateComponent(null);
  },
  methods: {
    populateComponent(account) {
       if (account != null){
         this.defaultMT4Account = account;
       }else{
          accountService.getDefaultMt4Account().then(r => {
            this.defaultMT4Account = r.data;
          });
       }
    },
    goToDeposit() {
      if (this.selectedAmount && this.selectedAmount > 0) {
        this.$router.push("/client/deposit/" + this.selectedAmount);
      } else {
        this.$router.push("/client/deposit");
      }
    },
    selectAmount(amount) {
      this.selectedAmount = amount;
    },
    populateLatestPosts() {
      this.loader.posts = true;
      dashSrv
        .getBlog()
        .then(json => {
          this.posts = json.posts;
        })
        .finally(() => {
          this.loader.posts = false;
        });
    },
    populateNews() {
      this.loader.news = true;
      dashSrv
        .getNews("es")
        .then(r => {
          this.news = JSON.parse(r.data);
        })
        .finally(() => {
          this.loader.news = false;
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Dashboard.vue